export default function KitOficial() {
  const items = [
    {
      img: "/kit-camiseta.jpg",
      titulo: "Camiseta Oficial",
      detalle: "Camiseta técnica conmemorativa Baños Run 2026.",
    },
    {
      img: "/kit-maletin.PNG",
      titulo: "Mochila Oficial",
      detalle: "Bolso de cuerdas oficial del evento.",
    },
    {
      img: "/kit-medalla.PNG",
      titulo: "Medalla de Finalista",
      detalle: "Medalla conmemorativa al cruzar la meta.",
    },
  ];

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-8 md:py-12">
      <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-12">
        <div className="text-center mb-8 md:mb-10">
          <p className="text-xs md:text-sm text-primary-500 font-semibold tracking-widest uppercase">
            Incluido con tu inscripción · $20
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 tracking-wide mt-2">
            KIT CORREDOR OFICIAL
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-2xl mx-auto">
            Cada atleta inscrito recibe el kit oficial Baños Run 2026: camiseta técnica, mochila,
            medalla de finalista, dorsal y chip de cronometraje.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-6">
          {items.map((it) => (
            <div
              key={it.titulo}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="aspect-square bg-white flex items-center justify-center p-3">
                <img src={it.img} alt={it.titulo} className="max-h-full max-w-full object-contain" />
              </div>
              <div className="p-4 text-center">
                <p className="font-heading text-xl text-foreground-950 tracking-wide">{it.titulo}</p>
                <p className="text-sm text-foreground-500 mt-1">{it.detalle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
